$('.dropdown').mouseenter(function () {
  $(this).find('.wrap').addClass('is-dropdown');

});
$('.dropdown').mouseleave(function () {
  $(this).find('.wrap').removeClass('is-dropdown');

});
